import { Box, Dialog, Text } from "@primer/react";
import { createPortal } from "react-dom";
import { useAppDispatch } from "../hooks/useAppDispatch";
import { useAuth } from "../hooks/useAuth";
import { NotifyHelper } from "../helpers/toast";
import { rootActions } from "../state/actions/rootActions";
import { ChangePasswordForm } from "./ChangePasswordForm";

interface IProps {
    isOpen: boolean;
    onClose: () => void;
}

/**
 * Modal đổi mật khẩu TỰ NGUYỆN (từ Header). Dùng chung <ChangePasswordForm> với màn hình buộc đổi.
 * Đổi thành công → toast + thay token mới (backend trả JWT mới) rồi đóng modal.
 *
 * Wrap createPortal(document.body): Primer Dialog legacy render inline, không tự portal — khi mount
 * trong Header (position: sticky → stacking context) sẽ bị table sticky cells đè. Portal ra body để
 * escape stacking context cha.
 */
export const ChangePasswordDialog = ({ isOpen, onClose }: IProps) => {
    const dispatch = useAppDispatch();
    const { user } = useAuth();

    return createPortal(
        <Dialog
            isOpen={isOpen}
            onDismiss={onClose}
            aria-labelledby="change-password-title"
            sx={{ width: 480, maxWidth: "92vw" }}
        >
            <Dialog.Header id="change-password-title">Đổi mật khẩu</Dialog.Header>
            <Box sx={{ p: 3 }}>
                <Text as="p" sx={{ fontSize: 1, color: "#666", mb: 2 }}>
                    Mật khẩu mới tối thiểu 8 ký tự, gồm ít nhất 3/4 nhóm: chữ thường, chữ HOA, số, ký tự đặc biệt.
                </Text>
                <ChangePasswordForm
                    maSv={user?.ma_sv}
                    onCancel={onClose}
                    onSuccess={(res) => {
                        NotifyHelper.Success(res.message);
                        if (res.access_token) {
                            dispatch(
                                rootActions.auth.PASSWORD_CHANGED({
                                    access_token: res.access_token,
                                    expires_at: res.expires_at || "",
                                })
                            );
                        }
                        onClose();
                    }}
                />
            </Box>
        </Dialog>,
        document.body
    );
};

export default ChangePasswordDialog;
